import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    Popover,
    PopoverHeader,
    PopoverBody,
    Col,
    Row,
    Button
} from 'reactstrap';
import PeriodSelect from "../../../periodSelect/PeriodSelect.container";
import _ from 'lodash';
import './AddPeriodPopover.css';
import moment from "moment";
import {AVAILABLE_CONSENT_PERIODS} from "../../../../../constants/constants";

const defaultPeriodType = AVAILABLE_CONSENT_PERIODS.MONTH;
const defaultPeriodNum = '1';

class AddPeriodPopover extends Component {
    constructor(props) {
        super(props);

        this.state = {
            periodType: defaultPeriodType,
            periodNum: defaultPeriodNum
        };
    }

    render() {
        if (!this.props.isOpen) {
            return null;
        }

        return (
            <Popover className="add-period-popover"
                     key={this.props.target}
                     isOpen={this.props.isOpen}
                     placement='bottom'
                     toggle={this.toggle}
                     target={this.props.target}>
                <PopoverHeader className="add-period-popover-header">
                    <Row>
                        <Col>{_.get(this.props.translation, 'consents.current_expire_date_label')}</Col>
                        <Col>{this.props.currentExpireDate.format('LL')}</Col>
                    </Row>
                    {this.renderNextExpireDate()}
                </PopoverHeader>
                <PopoverBody className="add-period-popover-body">
                    <PeriodSelect onPeriodNumChange={this.handleChange('periodNum')}
                                  showPopover={false}
                                  onPeriodTypeChange={this.handleChange('periodType')}
                                  periodType={this.state.periodType}
                                  periodNum={this.state.periodNum}/>
                    <Row>
                        <Col className='extend-consent-button-container'>
                            <Button className="olive-green-btn"
                                    block
                                    onClick={this.props.onExpandConsent}>
                                {_.get(this.props.translation, 'consents.extend_consent_button')}
                            </Button>
                        </Col>
                    </Row>
                </PopoverBody>
            </Popover>
        )
    }

    renderNextExpireDate() {
        if (_.isNil(this.props.currentExpireDate) || this.state.periodType === AVAILABLE_CONSENT_PERIODS.FOREVER) {
            return null;
        }

        return (
            <Row>
                <Col>{_.get(this.props.translation, 'consents.next_expire_date_label')}</Col>
                <Col>{moment(this.props.currentExpireDate).add(this.state.periodNum, this.state.periodType).format('LL')}</Col>
            </Row>
        );
    }

    handleChange = (fieldName) => (e) => {
        this.setState({[fieldName]: e.target.value});
    };

    toggle = () => {
        this.setState({periodType: defaultPeriodType, periodNum: defaultPeriodNum});
        this.props.toggle();
    }
}

AddPeriodPopover.propTypes = {
    isOpen: PropTypes.bool,
    target: PropTypes.string,
    currentExpireDate: PropTypes.object,
    translation: PropTypes.object,
    onExpandConsent: PropTypes.func,
    toggle: PropTypes.func
};

export default AddPeriodPopover;



// WEBPACK FOOTER //
// ./src/components/consentManagement/consentsList/activeConsentsList/addPeriodPopover/AddPeriodPopover.js